'use client'

import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

type CornerGradientProps = {
  corner: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  size?: string
  color?: string | undefined
}

const variants = cva('absolute pointer-events-none z-20 aspect-[360/320] blur-3xl', {
  variants: {
    corner: {
      'top-left': 'left-0 top-0 -translate-x-12 rotate-90',
      'top-right': 'right-0 top-0 rotate-180 translate-x-12',
      'bottom-left': 'left-0 bottom-0 rotate-0 -translate-x-12',
      'bottom-right': 'right-0 bottom-0 -rotate-90 translate-x-12',
    },
  },
})

export default function CornerGradient({
  corner,
  size,
  color,
  className,
}: CornerGradientProps & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(variants({ corner }), size ? size : 'w-[20vw]', className)}>
      <div
        className={cn(
          'absolute h-[90%] w-[55%] rounded-full transition-colors duration-500',
          color ? color : 'bg-primary-200',
        )}
      ></div>
      <div
        className={cn(
          'absolute bottom-0 left-[20%] h-[55%] w-[55%] rounded-full transition-colors duration-500',
          color ? color : 'bg-fuchsia-200',
        )}
      ></div>
      <div
        className={cn(
          'absolute bottom-0 left-[40%] h-[35%] w-[55%] rounded-full transition-colors duration-500',
          color ? color : 'bg-violet-200',
        )}
      ></div>
    </div>
  )
}
